// Web-Audio alert chime + a small localStorage preference. No asset files needed.
let _ctx = null;

function ctx() {
  if (!_ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    _ctx = new AC();
  }
  if (_ctx.state === "suspended") _ctx.resume().catch(() => {});
  return _ctx;
}

// Pleasant two-note rising chime.
export function playAlertChime() {
  try {
    const c = ctx();
    if (!c) return;
    const now = c.currentTime;
    [880, 1174.66].forEach((freq, i) => {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      osc.connect(gain);
      gain.connect(c.destination);
      const t = now + i * 0.16;
      gain.gain.setValueAtTime(0, t);
      gain.gain.linearRampToValueAtTime(0.28, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.45);
      osc.start(t);
      osc.stop(t + 0.47);
    });
  } catch { /* ignore */ }
}

export function soundEnabled() {
  return localStorage.getItem("aurum_sound_alerts") !== "off";
}

export function setSoundEnabled(v) {
  localStorage.setItem("aurum_sound_alerts", v ? "on" : "off");
}
